module.exports = __webpack_public_path__ + "img/ezhou-ez.53ae79b1.png";